<template>
  <div style="text-align: center; padding: 10px">
    <h4 v-if="sts === 2">
      <md-icon class="text-danger">block</md-icon> Xəta baş verdi!
    </h4>
    <h4 v-if="sts === 1">
      <md-icon class="text-info">autorenew</md-icon> Yüklənir...
    </h4>
    <h4 v-if="sts === 3">
      <md-icon class="text-warning">help_outline</md-icon> Məlumat tapılmadı!
    </h4>
  </div>
</template>

<script>
export default {
  props: {
    status: Number,
  },
  computed: {
    sts() {
      return this.status;
    },
  },
};
</script>
